import styled from 'styled-components';

interface IIconProps {
  active: boolean;
}

export const SIcon = styled.div<IIconProps>`
  font-size: 14px !important;
  filter: opacity(0.4);
  color: ${({ theme }) => theme.colors.tertiaryText} !important;

  ${({ active, theme }) =>
    active &&
    `
    color: ${theme.colors.quinaryText} !important;
    filter: none !important;`}
`;
